import React from 'react';
import PropTypes from 'prop-types';
import api from 'lib/api';
import appState from '../../state/App';
import userState from "state/User";
import { LoadingSpinner } from "@dataplan/react-components/dist/components/ui/loading_spinner";
import { AuthenticatorCodeDropdown } from "./index";

import styles from './SetupSharedStyles.module.scss';

class QRcode extends React.Component {

    static propTypes = {
        userState: PropTypes.shape(userState.getPropTypes()).isRequired,
        visible: PropTypes.bool,
    }

    static defaultProps = {
        visible: false,
    }

    /**
     * Creates a new instance of the component
     *
     * @param {object} props Input props
     * @return {void}
     */
    constructor (props) {
        super(props);

        this.state = {
            QRUrl: "",
            code: "",
        };
    }

    /**
     * Updates the component based on whether the draw is visible
     *
     * @param {object} prevProps The prev props
     */
    componentDidUpdate = (prevProps) => {
        const { visible } = this.props;

        if (visible !== prevProps.visible && !this.props.userState.mfa_totp) {
            this.handleAPI();
        }
    }

    /**
     * Called once the component has been torn down
     *
     * @return {void}
     */
    componentWillUnmount = () => {
        const { QRUrl } = this.state;

        if (QRUrl) {
            window.URL.revokeObjectURL(QRUrl);
        }
    }

    /**
     * Handles the API call
     */
    handleAPI () {
        api.get("/auth/mfa/totp/setup")
            .then(({data}) => {
                this.formatCode(data);
                api.get("/auth/mfa/totp/setup/qr", { responseType: 'blob' })
                    .then((response) => {
                        this.setState({
                            QRUrl: window.URL.createObjectURL(response.data),
                        });
                    }).catch(() => {
                        appState.addNotification({
                            text: `Failed to load QR code`,
                            type: "error",
                            duration: 0,
                        });
                    });
            }).catch((apiError) => {
                appState.addNotification({
                    text: `Failed to load 16 digit code`,
                    type: "error",
                    duration: 0,
                });
            });
    }

    /**
     * Formats the code
     *
     * @param {string} code the 16 digit authenticator code
     */
    formatCode = (code) => {
        const authCode = code.key;
        const formattedCode = authCode.match(/.{1,3}/g);
        this.setState({
            code: formattedCode.join("-"),
        });
    }

    /**
     * Renders the QR code
     *
     * @return {ReactElement} QR code
     */
    renderQRCode () {
        const {QRUrl} = this.state;

        if (!QRUrl) {
            return (
                <div className={styles.QRcontainer}>
                    <LoadingSpinner label="Loading" />
                </div>
            );
        }

        return (
            <div className={styles.QRcontainer}>
                <img
                    src={QRUrl}
                    alt="The QR code to setup multi-factor authentication"
                />
            </div>
        );
    }

    /**
     * Renders the dropdown
     *
     * @return {ReactElement} 16 digit dropdown
     */
    renderDropdown () {
        return (
            <AuthenticatorCodeDropdown code={this.state.code} />
        );
    }

    /**
     * Renders the QR component once loaded
     *
     * @return {ReactElement} QR code
     */
    render () {
        return (
            <>
                {this.renderQRCode()}
                {this.renderDropdown()}
            </>
        );
    }

}

export default userState.attachState(appState.attachState(QRcode));
